import { Pagination, QueryParams } from "@/models/query-params.model";
import { Observable } from "rxjs";
import api from "../api-config/rxjs-config";
import { Agenda } from "@/models/agenda.model";

export class AgendaRest {
  baseURL = "/talk";
  baseDownloadVideo = "/access-recorded-class";
  getAllAgenda(params?: QueryParams): Observable<Pagination<Agenda>> {
    const url: string = `/agenda`;
    return api.get(url, params, this.baseURL);
  }

  getAgendaById(classId: string): Observable<Agenda> {
    const url: string = `/agenda/${classId}`;
    return api.get(url, {}, this.baseURL);
  }

  addAgenda(data: any): Observable<Agenda | void> {
    const url: string = `/rooms`;
    return api.post(url, data, {}, this.baseURL);
  }

  delete(hash: string): Observable<any> {
    const url: string = `/rooms/${hash}`;
    return api.delete(url, this.baseURL);
  }
  downloadLive(hash: string): Observable<any> {
    const responseType = "blob";
    return api.get(hash, {}, this.baseDownloadVideo, responseType);
  }
}
